import { App as AntApp, ConfigProvider } from 'antd'
import { useEffect } from 'react'
import { BrowserRouter, useLocation } from 'react-router-dom'
import { Layout } from '@/components/Layout'
import { AppRoutes } from '@/routes'
import { setMessageInstance, setNotificationInstance } from '@/utils/notification'

// Initialize global notification/message instances from Ant Design App context
function NotificationProvider({ children }: { children: React.ReactNode }) {
  const { notification, message } = AntApp.useApp()

  useEffect(() => {
    setNotificationInstance(notification)
    setMessageInstance(message)
  }, [notification, message])

  return <>{children}</>
}

function AppContent() {
  const location = useLocation()
  const isLoginPage = location.pathname === '/login'

  if (isLoginPage) {
    return <AppRoutes />
  }

  return (
    <Layout>
      <AppRoutes />
    </Layout>
  )
}

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          borderRadius: 6,
          colorBorderSecondary: '#e8e8e8',
          colorSplit: '#e8e8e8',
        },
      }}
    >
      <BrowserRouter>
        <AntApp>
          <NotificationProvider>
            <AppContent />
          </NotificationProvider>
        </AntApp>
      </BrowserRouter>
    </ConfigProvider>
  )
}

export default App
